module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsValentine@2x.19839c5.jpg";